import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";
import SubmenuContent from "./SubmenuContent";

const { Box, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon } = Chakra;

const MenuLinkWithSubmenuMobile = ({ menulink, submenu }) => (
  <Accordion allowToggle>
    <AccordionItem border="none" bg="transparent">
      <AccordionButton
        py={0}
        pl={0}
        fontSize="lg"
        data-testid="open-kyr-items"
        sx={{ svg: { color: "primary.900" }, _expanded: { color: "primary.500", svg: { color: "primary.500" } } }}
      >
        <Box flex="1" textAlign="left">
          {menulink}
        </Box>
        <AccordionIcon boxSize={6} />
      </AccordionButton>
      <AccordionPanel px={4}>
        <SubmenuContent
          submenu={submenu}
          fontSize="md"
          color="greyscale.600"
          _hover={{ color: "primary.500" }}
          data-testid="kyr-list-items"
        />
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
);

export default MenuLinkWithSubmenuMobile;

MenuLinkWithSubmenuMobile.propTypes = {
  menulink: PropTypes.node.isRequired,
  submenu: PropTypes.arrayOf(
    PropTypes.shape({
      page: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
};
